const getAuthHeader = () => {
  const userData = JSON.parse(localStorage.getItem('user_data'))

  const token = userData?.token?.access_token

  if (!token) {
    return {}
  }

  return {
    Authorization: `Bearer ${token}`
  }
}

const getAuthAndMultipartHeader = () => {
  const header = getAuthHeader()
  header['Content-Type'] = 'multipart/form-data'
  return header
}

export { getAuthHeader, getAuthAndMultipartHeader }
